class AdminPaymentErrorsController {

    $onInit() {
        this.errorDisplay = {}
        this.errorDisplay[this.error] = true;
        this.error = this.errorDisplay;
    }
}

AdminPaymentErrorsController.$inject = [ ];

export default AdminPaymentErrorsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/admin.payment.errors.controller.js